export default "assets/images/6c5dba7f7d76e74c3a8c7c5b1c3fc544.png";